import axios from "axios";

const _BaseAPIService = {
  retrieveToken: () => {
    try {
      const userString = localStorage.getItem("user");

      const user = JSON.parse(userString);

      const token = user?.token;

      return token;
    } catch (error) {
      console.error("Error retrieving token:", error);
      return null;
    }
  },
  instance: axios.create({
    baseURL: window.APP_CONFIG.baseapi,
    // If you have multiple base URLs, ensure you handle them accordingly
    // baseURL: window.APP_CONFIG.api2.baseapi,
  }),

  storeToken: async (token) => {
    try {
      await localStorage.setItem("jwtToken", token);
    } catch (error) {
      console.error("Error storing token:", error);
    }
  },
};

_BaseAPIService.instance.interceptors.request.use(
  async (config) => {
    try {
      const token = await _BaseAPIService.retrieveToken();
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    } catch (error) {
      console.error("Error intercepting request:", error);
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// _BaseAPIService.instance.interceptors.response.use(function (error) {
//   if (error.response.status === 401) {
//     localStorage.clear();
//     window.location.href = "/";
//   }
//   // Do something with response error
//   return Promise.reject(error);
// });

// _BaseAPIService.instance.interceptors.response.use(
//   function (response) {
//     try {
//       // Do something with the response data
//       // console.log("Response intercepted:", response);
//     } catch (error) {
//       // console.error("Error intercepting response:", error);
//     }
//     return response;
//   },
//   function (error) {
//     if (error.response.status === 401) {
//       localStorage.clear();
//       window.location.href = "/";
//     }
//     // Do something with response error
//     return Promise.reject(error);
//   }
// );
export default _BaseAPIService;
